import { StepStatus } from 'bold-ui'

export const getConnectorStatus = (
  activeStepIdx: number,
  completedStepsIdx: number[],
  stepIndex: number
): StepStatus => {
  const nextStepIdx = stepIndex + 1

  if (completedStepsIdx.includes(nextStepIdx)) return 'completed'
  if (activeStepIdx === nextStepIdx) return 'active'
  return 'incompleted'
}

export const getStatus = (activeStepIdx: number, completedStepsIdx: number[], stepIndex: number): StepStatus => {
  if (completedStepsIdx.includes(stepIndex)) return 'completed'
  if (activeStepIdx === stepIndex) return 'active'
  return 'incompleted'
}
